"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Collaboration = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Collaboration_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.973 2.332a2 2 0 1 0-3.945 0 6.016 6.016 0 0 0-3.696 3.695 2 2 0 1 0 0 3.945 6.017 6.017 0 0 0 3.695 3.696 2 2 0 1 0 3.945 0 6.016 6.016 0 0 0 3.696-3.695 2 2 0 1 0 0-3.945 6.016 6.016 0 0 0-3.695-3.696ZM8 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1.562.249C9.196 3.707 8.632 4 8 4a1.996 1.996 0 0 1-1.562-.751 5.013 5.013 0 0 0-3.19 3.189 1.996 1.996 0 0 1 0 3.125 5.013 5.013 0 0 0 3.19 3.188C6.804 12.293 7.368 12 8 12s1.196.293 1.562.751a5.013 5.013 0 0 0 3.189-3.189A1.996 1.996 0 0 1 12 8c0-.632.293-1.196.751-1.562a5.013 5.013 0 0 0-3.189-3.19ZM2 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm13-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-7 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Collaboration_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Collaboration;
exports["default"] = _default;